const CRISP_WEBSITE_ID = "7cd6518c-b464-422b-8865-4484b02ec7c6";

// Only initialize in production
const isProduction = process.env.NODE_ENV === "production";

declare global {
	interface Window {
		$crisp: unknown[];
		CRISP_WEBSITE_ID: string;
	}
}

export const initCrisp = () => {
	if (!isProduction) return;

	window.$crisp = [];
	window.CRISP_WEBSITE_ID = CRISP_WEBSITE_ID;

	const script = document.createElement("script");
	script.src = "https://client.crisp.chat/l.js";
	script.async = true;
	document.head.appendChild(script);
};
